
export class MovilMarker {

    constructor(        
        public nombre: string,
        public lat: number,
        public lng: number,
        public rotacion: number,
    ){}

}